import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Users, Award, BookOpen } from 'lucide-react';

const highlights = [
  {
    icon: Clock,
    title: 'Duration',
    description: '4-month program with flexible learning'
  },
  {
    icon: Users,
    title: 'Format',
    description: 'Online learning + 2-day in-person training'
  },
  {
    icon: Award,
    title: 'Certification',
    description: 'Joint certificate from MUBS, Frankfurt School & ARIN'
  },
  {
    icon: BookOpen,
    title: 'Credits',
    description: 'Earn 3 ECTS credits'
  }
];

export default function ProgramHighlights() {
  return (
    <section className="py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {highlights.map((item, index) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-lg"
            >
              <item.icon className="h-8 w-8 text-green-600 mb-4" />
              <h3 className="text-xl font-semibold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-gray-600">{item.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}